var cache = {};
/**
 * padString pads string with N number of characters in front of the supplied value
 * @param padding
 * @param char
 * @param value
 * @return {string} Padded string
 */
export function padString(length, char, value) {
    var k = length.toString() + char + value;
    if (!cache[k]) {
        var s = value || "";
        while (s.length < length) {
            s = char + s;
        }
        cache[k] = s;
    }
    return cache[k];
}
export var padTime = padString.bind(undefined, 2, "0");
//# sourceMappingURL=PadString.js.map